import { Center, Loader, Alert, SimpleGrid } from '@mantine/core';
import { AlertCircle } from 'react-feather';
import type { CohortWithDetails } from '../../../types';
import { useOverviewStats } from '../hooks/useOverviewStats';
import { MilestoneProgress, RecentActivityFeed } from './overview';

interface ActivityTabProps {
  cohort: CohortWithDetails;
  isActive?: boolean;
}

export function ActivityTab({ cohort, isActive }: ActivityTabProps) {
  const { stats, loading, error } = useOverviewStats({
    cohortId: cohort.id,
    enabled: isActive,
  });

  if (loading) {
    return (
      <Center py="xl">
        <Loader size="lg" />
      </Center>
    );
  }

  if (error || !stats) {
    return (
      <Alert
        icon={<AlertCircle size={16} />}
        color="red"
        title="Error loading activity"
      >
        {error || 'Failed to load activity data'}
      </Alert>
    );
  }

  return (
    <SimpleGrid cols={{ base: 1, md: 2 }} spacing="lg">
      <MilestoneProgress milestones={stats.milestones} />
      <RecentActivityFeed activities={stats.recentActivity} />
    </SimpleGrid>
  );
}

export default ActivityTab;
